// extracted by mini-css-extract-plugin
export default {"root":"NotificationBox_root__AIm0k","notificationText":"NotificationBox_notificationText__mBWcb"};